<template lang="pug">
  div
    Section1Widget(to="/")
    b-card.text-left
      b-card-title {{tlang('about_us.title')}}
      b-card-text {{tlang('about_us.verbiage')}}
      b-embed( v-if="tlang('about_us.video_url') && tlang('about_us.video_url').includes('youtube')"
        type="iframe"
        aspect="16by9"
        :src="tlang('about_us.video_url')"
        allowfullscreen)      
      b-embed( v-else-if="tlang('about_us.video_url')"
        type="video"
        controls
        muted="true"
        preload="metadata"
        :poster="assets_base_url + '/img/Video_Link_image.jpg'"
        :src="tlang('about_us.video_url')"
        allowfullscreen)
</template>
<script>
import Section1Widget from './components/Section1Widget.vue'
import LangMixin from './common/lang/util'
export default {
  components: {
    Section1Widget
  },
  mixins: [LangMixin],
  name: 'AboutUs',
  data: function(){
    return {
      assets_base_url: process.env.VUE_APP_ASSETS_URL,
    }
  }
}
</script>
